import React from "react";
export const BonusTabIcon = (): JSX.Element => {
  return (
    <svg
      viewBox="0 0 24 24"
      width="24"
      height="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m9 23c4.4183 0 8-3.5817 8-8s-3.5817-8-8-8c-4.4183 0-8 3.5817-8 8s3.5817 8 8 8zm0-2c3.3137 0 6-2.6863 6-6s-2.6863-6-6-6c-3.3137 0-6 2.6863-6 6s2.6863 6 6 6z"
        clipRule="evenodd"
        fill="#7800FF"
        fillRule="evenodd"
      />
      <path
        d="m7.2026 7.2027c0.8156-3.5528 3.997-6.2027 7.7973-6.2027 4.4183 0 8 3.5817 8 8 0 3.8003-2.6498 6.9817-6.2027 7.7973 0.1327-0.5777 0.2027-1.1793 0.2027-1.7973 0-0.1135-0.0023-0.2265-7e-3 -0.3389 2.3341-0.8217 4.007-3.046 4.007-5.6611 0-3.3137-2.6862-6-6-6-2.615 0-4.8394 1.673-5.661 4.007-0.11239-0.00468-0.22538-0.00705-0.33893-0.00705-0.61797 0-1.2196 0.07007-1.7973 0.2027z"
        clipRule="evenodd"
        fill="#7800FF"
        fillRule="evenodd"
      />
      <path
        d="M9 10L9.56344 12.2537C9.83215 13.3286 10.6714 14.1679 11.7463 14.4366L14 15L11.7463 15.5634C10.6714 15.8321 9.83215 16.6714 9.56344 17.7463L9 20L8.43656 17.7463C8.16785 16.6714 7.3286 15.8321 6.25374 15.5634L4 15L6.25374 14.4366C7.3286 14.1679 8.16785 13.3286 8.43656 12.2537L9 10Z"
        fill="#7800FF"
      />
    </svg>
  );
};
